<template>
  <Transition
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
  >
    <div v-show="selected" ref="content" v-bind="$attrs">
      <slot />
    </div>
  </Transition>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
})

const selected = ref(props.open)
const content = ref(null)

watch(
  () => props.open,
  (newValue) => {
    selected.value = newValue
  },
)

async function toggle() {
  selected.value = !selected.value
  if (selected.value) {
    emit('open')
  }
}

async function close() {
  await nextTick()
  if (selected.value) {
    selected.value = false
  }
}

function beforeEnter() {
  if (content.value) {
    content.value.style.height = '0'
  }
}

function enter() {
  if (content.value) {
    content.value.style.height = `${content.value.scrollHeight}px`
  }
}

function afterEnter() {
  emit('opened')
  if (content.value) {
    content.value.style.opacity = '1'
  }
}

function beforeLeave() {
  if (content.value) {
    content.value.style.opacity = '1'
    content.value.style.height = `${content.value.scrollHeight}px`
    // Force recalculation
    void content.value.scrollHeight
  }
}

function leave() {
  emit('closed')
  if (content.value) {
    content.value.style.height = '0'
  }
}

async function setHeight(height) {
  await nextTick()
  if (content.value) {
    height = height || content.value.scrollHeight
    content.value.style.height = `${height}px`
  }
}

const emit = defineEmits(['open', 'opened', 'closed'])

defineExpose({
  toggle,
  close,
  setHeight,
})
</script>
